module.exports = {"title":"1:1 문의","inquiryButton":"문의하기","typePlaceholder":"유형","searchInputPlaceholder":"검색어를 입력하세요.","searchWordPlaceholder":"검색어를 입력하세요","writerPlaceholder":"작성자","selectAllOption":"전체선택","checkingOnly":"확인중 게시물만 보기","replyStatus":"답변 여부","type":"유형","postTitle":"제목","writer":"작성자","date":"작성일","answered":"답변완료","checking":"확인중","noPosts":"등록된 게시물이 없습니다.","prev":"이전","next":"다음","more":"더보기","typeService":"서비스","typeEvent":"이벤트","typeUpdate":"업데이트","golfClubCount":"골프클럽({n})"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/ko/cs101.json
// module id = eg5u
// module chunks = 2